module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "lxm-prev-next nav"
  }, [_c('div', {
    staticClass: "lxm-prev-next__container nav-center"
  }, [_c('a', {
    staticClass: "lxm-prev-next__half nav-item is-tab",
    class: {
      'is-disabled': !_vm.prevAble
    },
    on: {
      "click": _vm.prevClicked
    }
  }, [_vm._v("上一条")]), _vm._v(" "), _c('a', {
    staticClass: "lxm-prev-next__half nav-item is-tab",
    class: {
      'is-disabled': !_vm.nextAble
    },
    on: {
      "click": _vm.nextClicked
    }
  }, [_vm._v("下一条")])])]), _vm._v(" "), _c('div', {
    staticClass: "lxm-prev-next-placeholder"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45b2f847", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45b2f847!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmPrevNext.vue
// module id = 845
// module chunks = 0